var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63743 0H12.9928L19.2266 6.49776V19.1359C19.2266 20.7191 17.9458 22 16.3681 22H5.63743C4.05423 22 2.77338 20.7191 2.77338 19.1359V2.86406C2.77335 1.28086 4.0542 0 5.63743 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9872 0V4.44828C12.9872 5.55285 13.8827 6.44828 14.9872 6.44828H19.2266L12.9872 0Z",
    fill: "white",
    fillOpacity: 0.59
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95627 16.415V12.3965H7.66592C8.08921 12.3965 8.42455 12.5119 8.67742 12.7483C8.93029 12.9792 9.05674 13.2925 9.05674 13.6828C9.05674 14.0731 8.93029 14.3865 8.67742 14.6174C8.42455 14.8538 8.08921 14.9692 7.66592 14.9692H6.98425V16.415H5.95627ZM6.98425 14.0952H7.55048C7.70439 14.0952 7.82533 14.0622 7.90781 13.9852C7.99025 13.9138 8.03426 13.8148 8.03426 13.6829C8.03426 13.5509 7.99028 13.452 7.90781 13.3805C7.82536 13.3036 7.70442 13.2706 7.55048 13.2706H6.98425V14.0952ZM9.48 16.415V12.3965H10.9038C11.1841 12.3965 11.448 12.435 11.6954 12.5174C11.9428 12.5999 12.1682 12.7153 12.366 12.8748C12.564 13.0287 12.7234 13.2376 12.8388 13.5014C12.9488 13.7653 13.0092 14.0677 13.0092 14.4085C13.0092 14.7438 12.9488 15.0462 12.8388 15.31C12.7234 15.5739 12.564 15.7828 12.366 15.9367C12.1681 16.0961 11.9428 16.2116 11.6954 16.294C11.448 16.3765 11.1841 16.415 10.9038 16.415H9.48ZM10.486 15.5409H10.7828C10.9423 15.5409 11.0907 15.5244 11.2281 15.4859C11.36 15.4475 11.4865 15.387 11.6074 15.3045C11.7229 15.2221 11.8163 15.1066 11.8823 14.9527C11.9483 14.7988 11.9813 14.6174 11.9813 14.4085C11.9813 14.1941 11.9483 14.0127 11.8823 13.8588C11.8163 13.7049 11.7229 13.5894 11.6074 13.5069C11.4865 13.4245 11.3601 13.364 11.2281 13.3255C11.0907 13.2871 10.9423 13.2706 10.7828 13.2706H10.486V15.5409ZM13.526 16.415V12.3965H16.3846V13.2706H14.554V13.9137H16.0162V14.7823H14.554V16.415H13.526Z",
    fill: "white",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.e77f10f5d8f4f02e56e2754c567fd178.svg";
export { ForwardRef as ReactComponent };